import React from "react";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import PropTypes from "prop-types";

const styles = {
  button: {
    margin: 8
  },
  contentHeaderMenuLink: {
    textDecoration: "none",
    color: "white",
    padding: 8
  },
  content: {
    padding: "16px"
  }
};

function WarrantyClaimEditButton(props) {
  const { id, history } = props;

  function handleEditUser(id) {
    history.push(`/admin-warranty-claims/${id}/edit`);
  }

  return (
    <div>
      <Button variant="contained" color="secondary" style={styles.button} onClick={() => handleEditUser(id)}>
        Edit Warranty Claim
      </Button>
    </div>
  );
}

WarrantyClaimEditButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(withRouter, withStyles(styles))(WarrantyClaimEditButton);
